import React from 'react';
import StackTrace from 'stacktrace-js';
import Button from '../components/common/ui/Button';
import errorimg from '../assets/404.png';
import logo from '../assets/logo-gray.png';
import { getStoredValue } from './storagehelper';
import "../assets/css/ErrorPage.css";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null, // properly initialize error
    };
  }
    
  static getDerivedStateFromError(error) {  
    StackTrace.fromError(error).then(stackFrames => {
      const frame = stackFrames[0] || {};
      const functionName = "Function Name : " + (frame?.functionName || 'Unknown');
      const fileName = "File name : " + (frame?.fileName || 'Unknown');
      const lineNumber = "Line number : " + (frame?.lineNumber || 'Unknown');
      const time = "Date and Time : " + new Date().toISOString();

      const userAgent = navigator.userAgent;
      const browser = (() => {
        if (userAgent.includes("Firefox")) return "Firefox";
        if (userAgent.includes("Chrome") && !userAgent.includes("Edg")) return "Chrome";
        if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) return "Safari";
        if (userAgent.includes("Opera") || userAgent.includes("OPR")) return "Opera";
        if (userAgent.includes("Trident")) return "Internet Explorer";
        if (userAgent.includes("Edg")) return "Edge";
        return "Unknown";
      })();
      
      const logData = {
        Source: `${functionName}, ${fileName}, ${lineNumber}, ${time}`,
        Message: error?.message || error.toString() || 'Unknown error',
        CurrentURL: window.location.href,
        IPAddress: getStoredValue("cachedIP"),
        Browser: browser,
      };
      
      return fetch(`${process.env.REACT_APP_API_URL}/ErrorLog/logs`, {      
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          path: "Logs/CreateErrorLog",
          errorLog: JSON.stringify(logData)
        })
      });

    });
    return { hasError: true, error };
  }  

  render() {   
    if (this.state.hasError) {
      return (
        <div className="parent-container">
          <div className="error-container">
            <div className="error-logo">
              <img src={logo} alt="Logo" />
            </div>
            <div className="error-content">
              <div className="error-code">
                <img src={errorimg} alt="Logo" />
              </div>
              <p className="error-message">
                {this.state.error?.message || 'The Server encountered an internal error and unable to process your request at this time. Please try again after sometime or contact your administrator if the problem persists.'}
              </p>
              <div className="d-flex justify-content-center">
                <Button
                  variant="primary"
                  className="me-2"
                  onClick={() => { window.location.href = '/' }}
                  label="BACK TO LOGIN"
                  type="button"
                  status="primary"
                />
              </div>
            </div>
            <div className="error-footer">
              <p>Copyright © {new Date().getFullYear()} by inmate inbox. All Rights Reserved.</p>
            </div>
          </div>
        </div>
      );
    } 
    return this.props.children;
  }
}

export default ErrorBoundary;
